import { useAppRegion } from "@hooks/region/useAppRegion";
import { EBreakpoints, useBreakpoint } from "@hooks/useBreakpoint";
import { Group } from "@mantine/core";
import { useDidUpdate } from "@mantine/hooks";
import { useLocation } from "react-router";
import RegionSkinProductSelect from "../select/RegionSkinProductSelect";
import { LOL_GRADIENT } from "./LolRegionSelectorBanner";
import RegionButton from "./RegionButton";
import { VALORANT_GRADIENT } from "./ValorantRegionSelectorBanner";

import type { AppRegion } from "@core-types/region.enum";

interface IRegionSelectorBannerProps {
  className?: string;
  onRegionChange?: (region: AppRegion) => void;
}

const RegionSelectorBanner: React.FC<IRegionSelectorBannerProps> = ({
  className,
  onRegionChange,
}) => {
  const { currentRegion, changeRegion, allRegions } = useAppRegion();
  const { breakpoint } = useBreakpoint();
  const { pathname } = useLocation();

  const isValorant = pathname.includes("valorant");
  const gradient = isValorant ? VALORANT_GRADIENT : LOL_GRADIENT;

  /* Don't specify onRegionChange to avoid infinite loop */
  useDidUpdate(() => {
    onRegionChange?.(currentRegion);
  }, [currentRegion]);

  if (breakpoint > EBreakpoints.MD) {
    return (
      <Group className={`ml-11 ${className}`}>
        {allRegions.map((region) => (
          <RegionButton
            key={region.code}
            region={region}
            isSelected={region.code === currentRegion}
            onClick={changeRegion}
            gradientVariant={gradient}
            icon={region.whiteImage}
          />
        ))}
      </Group>
    );
  }

  return (
    <div className="xs:ml-4 w-full xs:max-w-[320px]">
      <RegionSkinProductSelect
        region={currentRegion}
        regions={allRegions}
        onRegionChange={changeRegion}
      />
    </div>
  );
};

export default RegionSelectorBanner;
